import { useState, useEffect, useCallback } from 'react';

export default function CountdownTimer() {
  const getTarget = useCallback(() => {
    const key = 'designcarat_countdown_target';
    const stored = localStorage.getItem(key);
    if (stored) { const t = parseInt(stored, 10); if (t > Date.now()) return t; }
    const target = Date.now() + 24 * 60 * 60 * 1000;
    localStorage.setItem(key, target.toString());
    return target;
  }, []);

  const calcRemaining = useCallback((target) => {
    const diff = Math.max(0, target - Date.now());
    return {
      hours: Math.floor(diff / (1000 * 60 * 60)),
      minutes: Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)),
      seconds: Math.floor((diff % (1000 * 60)) / 1000),
    };
  }, []);

  const [target] = useState(getTarget);
  const [time, setTime] = useState(() => calcRemaining(target));

  useEffect(() => {
    const id = setInterval(() => setTime(calcRemaining(target)), 1000);
    return () => clearInterval(id);
  }, [target, calcRemaining]);

  const pad = (n) => n.toString().padStart(2, '0');

  return (
    <div data-testid="countdown-timer" className="flex flex-col items-center gap-3 mb-8">
      <span className="uppercase text-xs tracking-[0.25em] font-bold text-red-400 font-body animate-pulse" data-testid="limited-spots-label">
        Limited Spots Left
      </span>
      <div className="flex items-center gap-2" data-testid="countdown-digits">
        <TimeBlock value={pad(time.hours)} label="HRS" />
        <span className="text-[#ccc] font-heading text-xl -mt-4">:</span>
        <TimeBlock value={pad(time.minutes)} label="MIN" />
        <span className="text-[#ccc] font-heading text-xl -mt-4">:</span>
        <TimeBlock value={pad(time.seconds)} label="SEC" />
      </div>
    </div>
  );
}

function TimeBlock({ value, label }) {
  return (
    <div className="flex flex-col items-center">
      <div className="card-elevated font-heading font-black text-[#111] tabular-nums text-2xl sm:text-3xl px-3 py-2 min-w-[56px] text-center">
        {value}
      </div>
      <span className="text-[9px] uppercase tracking-widest text-[#aaa] font-body mt-1.5">{label}</span>
    </div>
  );
}
